import { COOKIE_IDS, SERVER_ERROR_MESSAGES } from '../../Constants/Constants';
import APIClient from '../../Services/AxiosClient';
import { setCookie } from '../../Utils/CookieUtils';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';
export const timeFormatRefreshment = (data: any) => {
  const timeFormat = data?.find((item: any) => item?.key === 'preferredtime')?.value;
  if (timeFormat) {
    setCookie(COOKIE_IDS?.PREFERRED_TIME_FORMAT, timeFormat);
  }
};
export const fetchPreferences = async () => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.PREFERENCES?.GETPREFERENCES,
      method: 'get',
    });
    timeFormatRefreshment(response?.preferences);
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const savePreferences = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.PREFERENCES?.UPDATEPREFERENCES,
      method: 'put',
      data: queryPayload?.payload,
    });
    timeFormatRefreshment(response?.preferences);
    queryPayload?.callback({ message: 'Preference saved successfully', status: 'SUCCESS' });
    return response;
  } catch (err) {
    queryPayload?.callback &&
      queryPayload?.callback({ message: SERVER_ERROR_MESSAGES?.generalMsg, status: 'FAILED' });
    console.error('Activity : ', err);
    return null;
  }
};
